module.exports = __webpack_public_path__ + "img/logo_bidv.bf0bdff6.svg";